import { GREY_B, GREY_I, GREY_S } from 'app/constants/Colors';
import { IStyles } from 'app/utils/css';

export enum FontWeight {
  Bold = 700,
  Normal = 400,
  SemiBold = 600,
}

export enum TextTransition {
  TransitionA = 'color 0.15s ease-out',
}

type Color = typeof GREY_I | typeof GREY_B | typeof GREY_S;
type FontSize = '32px' | '28px' | '24px' | '18px' | '16px' | '14px' | '12px';
type LetterSpacing = '0.8px' | '1.2px';
type TextTransform = 'uppercase';

export interface ITextCSSArgs {
  color: Color;
  fontSize: FontSize;
  fontWeight?: FontWeight;
  letterSpacing?: LetterSpacing;
  textTransform?: TextTransform;
  transition?: TextTransition;
}

/**
 * Restricts content to the standard/common set of text properties.
 */
export const getTextStyles = (textArgs: ITextCSSArgs): IStyles => ({
  ...textArgs,
  // For p tags and such.
  letterSpacing: textArgs.letterSpacing || '0.8px',
  margin: '0',
});

export const cardHeaderStyles =
  getTextStyles({ color: GREY_B, fontSize: '16px', fontWeight: FontWeight.SemiBold, letterSpacing: '0.8px' });

export const contentsStyles =
  getTextStyles({ color: GREY_S, fontSize: '16px', fontWeight: FontWeight.Normal, letterSpacing: '0.8px' });

export const inputLabelStyles =
  getTextStyles({ color: GREY_B, fontSize: '14px', fontWeight: FontWeight.SemiBold, letterSpacing: '0.8px' });

export const pageContentsStyles =
  getTextStyles({ color: GREY_S, fontSize: '16px', fontWeight: FontWeight.Normal, letterSpacing: '0.8px' });

export const statusPageContentsStyles =
  getTextStyles({ color: GREY_B, fontSize: '16px', fontWeight: FontWeight.Normal, letterSpacing: '0.8px' });

export const pageHeaderStyles = getTextStyles({
  color: GREY_B,
  fontSize: '32px',
  fontWeight: FontWeight.SemiBold,
  letterSpacing: '1.2px',
  textTransform: 'uppercase',
});

export const sectionHeaderStyles = getTextStyles({
  color: GREY_B,
  fontSize: '24px',
  fontWeight: FontWeight.Normal,
  letterSpacing: '1.2px',
});

// This is an attempt to get the best browser support for word break wrapping
// word-break is considered deprecated, but it is also the only option that
// has the desired effect on most browsers.
export const wordBreakWrappingStyles: IStyles = {
  wordBreak: 'break-word',
  overflowWrap: 'anywhere', // This is the new version but is only supported on Firefox.
};
